import React, { Component } from 'react';
import { Translate } from '../contexts/Language';
import { ErrorMessage } from './Validator';
import { Service } from '../services';
import { Config } from '../config';

export class CurrencyEdit extends Component {

    constructor(props) {
        super(props)

        this.state = {
            formData: {
                currency: this.props.Data.currency,
                bid: this.props.Data.bid,
                ask: this.props.Data.ask
            },
            validation: {
                error: false,
                message: ""
            }
        }
    }
    onFormChange(e, key) {

        let formData = this.state.formData;

        formData[key] = e.target.value;

        this.setState({
            formData
        });

    }
    onSave() {

        Config.utilities.loadingFetch();

        const postData={
            Bid:this.state.formData.bid,
            Ask:this.state.formData.ask,
            Currency:this.state.formData.currency
        }
        Service.User.UpdateCurrency(postData).then(response => {

            if (response.error) {

                this.setState({
                    validation: {
                        error: response.error,
                        message: response.message
                    }
                });
            }

            Config.utilities.loadingFetch();
        });
    }
    render() {
        return (
            <div className="col-md-4 mb-4">
                <ErrorMessage Validation={this.state.validation} />
                <div className="img-thumbnail p-3">
                    <div className="row">
                        <div className="form-group input-group-sm col-lg-5 pl-4">
                            <span className="badge badge-light font-14 p-2">Symbol {this.state.formData.currency}</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group input-group-sm col-lg-5 pl-4">
                            <label htmlFor="name">{Translate("Bid")}</label>
                            <input type="number" id="minimum" name="minimum" className="form-control input-sm" value={this.state.formData.bid} onChange={(e) => this.onFormChange(e, "bid")} />
                        </div>
                        <div className="form-group input-group-sm col-lg-5 pr-4">
                            <label htmlFor="name">{Translate("Ask")}</label>
                            <input type="number" id="maximum" name="maximum" className="form-control input-sm" value={this.state.formData.ask} onChange={(e) => this.onFormChange(e, "ask")} />
                        </div>
                        <div className="col-lg-2">
                            <button type="button" className="btn btn-primary float-right mr-2 mt-4" onClick={(e) => this.onSave()}>{Translate("Save")}</button>
                        </div>
                    </div>
                </div>
            </div>)
    }

}
